/*
  Aldo Shoes — Footer behaviour (sections/footer.liquid)

  1. Collapsible columns: native <details data-footer-accordion>. Always open (and
     not toggleable) on tablet/desktop, collapsed on phones.
  2. Newsletter: the same 3-step engine as the welcome popup
     (assets/newsletter.js AldoNewsletter.createStepper — email + preference →
     WhatsApp → confirmation) wired over the footer's own inline markup.
  3. "Preferencias de cookies": only shown when Shopify's privacy banner API
     (window.privacyBanner.showPreferences) exists; clicking it reopens the banner.
  4. Monochrome payment icons: strips the background plate of Shopify's colour
     payment cards (geometry heuristic, see snippets/payment-icons.liquid).

  Re-initialises on theme editor section reloads.
*/
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 767px)');

  /* ------------------------------------------------------------ Accordions */

  function syncAccordions() {
    var items = document.querySelectorAll('[data-footer-accordion]');
    Array.prototype.forEach.call(items, function (details) {
      var summary = details.querySelector('summary');
      if (MOBILE.matches) {
        details.open = false;
        if (summary) summary.removeAttribute('tabindex');
      } else {
        details.open = true;
        if (summary) summary.setAttribute('tabindex', '-1');
      }
    });
  }

  function initAccordions(root) {
    var items = root.querySelectorAll('[data-footer-accordion]');
    Array.prototype.forEach.call(items, function (details) {
      if (details.hasAttribute('data-footer-accordion-ready')) return;
      details.setAttribute('data-footer-accordion-ready', '');
      var summary = details.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (event) {
        // Desktop columns are plain headings: never collapse them.
        if (!MOBILE.matches) event.preventDefault();
      });
    });
    syncAccordions();
  }

  if (typeof MOBILE.addEventListener === 'function') {
    MOBILE.addEventListener('change', syncAccordions);
  } else if (typeof MOBILE.addListener === 'function') {
    MOBILE.addListener(syncAccordions);
  }

  /* ------------------------------------------------------------ Newsletter */

  function footerNewsletterSetActive(stepEl, isActive) {
    stepEl.classList.toggle('is-active', isActive);
    stepEl.setAttribute('aria-hidden', isActive ? 'false' : 'true');
  }

  function initFooterNewsletterBlock(root) {
    if (!root || root.hasAttribute('data-footer-newsletter-ready') || !window.AldoNewsletter) return;
    root.setAttribute('data-footer-newsletter-ready', '');

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-footer-newsletter-step]'));
    if (!steps.length) return;
    var statusEl = root.querySelector('[data-footer-newsletter-status]');
    var form1 = steps[0].querySelector('form');
    var form2 = steps[1] && steps[1].querySelector('form');

    var stepper = window.AldoNewsletter.createStepper({
      steps: steps,
      statusEl: statusEl,
      stepLabels: window.footerNewsletterStepLabels || [],
      setStepActive: footerNewsletterSetActive,
      step1: form1 && {
        form: form1,
        emailInput: form1.querySelector('[data-footer-newsletter-email]'),
        honeypotInput: form1.querySelector('[data-footer-newsletter-honeypot]'),
        tagsInput: form1.querySelector('input[name="contact[tags]"]'),
        errorEl: form1.querySelector('[data-footer-newsletter-error]'),
        submitBtn: form1.querySelector('[data-footer-newsletter-submit]'),
        preferenceInputs: form1.querySelectorAll('[data-footer-newsletter-preference]'),
      },
      step2: form2 && {
        form: form2,
        countrySelect: form2.querySelector('[data-footer-newsletter-country]'),
        phoneInput: form2.querySelector('[data-footer-newsletter-phone]'),
        errorEl: steps[1].querySelector('[data-footer-newsletter-phone-error]'),
        tagsInput: form2.querySelector('[data-footer-newsletter-phone-tags]'),
        emailInput: form2.querySelector('[data-footer-newsletter-phone-email]'),
        submitBtn: form2.querySelector('[data-footer-newsletter-phone-submit]'),
        skipBtn: steps[1].querySelector('[data-footer-newsletter-skip]'),
        countries: window.footerNewsletterCountries || [],
        defaultCountry: root.dataset.defaultCountry || 'PA',
      },
    });

    // Vuelta de un POST nativo (p. ej. tras el captcha de Shopify): el email
    // del paso 1 ya quedó guardado, así que se salta directo al paso 2.
    if (root.querySelector('[data-footer-newsletter-phone-posted="success"]')) {
      window.AldoNewsletter.markSubscribed();
      stepper.goToStep(3);
    } else if (root.querySelector('[data-footer-newsletter-posted="success"]')) {
      window.AldoNewsletter.markSubscribed();
      var postedEmail = form1 && form1.querySelector('[data-footer-newsletter-email]');
      var phoneEmailInput = form2 && form2.querySelector('[data-footer-newsletter-phone-email]');
      if (phoneEmailInput) phoneEmailInput.value = postedEmail ? postedEmail.value : '';
      stepper.goToStep(2);
    }
  }

  function initNewsletter(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-footer-newsletter]'), initFooterNewsletterBlock);
  }

  /* --------------------------------------------------- Cookie preferences */

  function privacyBannerAvailable() {
    return !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
  }

  function revealCookiePreferences() {
    if (!privacyBannerAvailable()) return false;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cookie-preferences]'), function (item) {
      item.hidden = false;
    });
    return true;
  }

  function initCookiePreferences() {
    if (!document.querySelector('[data-cookie-preferences]')) return;
    if (revealCookiePreferences()) return;
    // Shopify injects the banner script asynchronously: check again once the page
    // has loaded (and once more shortly after, for late consent scripts).
    window.addEventListener('load', function () {
      if (!revealCookiePreferences()) window.setTimeout(revealCookiePreferences, 2000);
    }, { once: true });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-preferences-trigger]');
    if (!trigger || !privacyBannerAvailable()) return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });

  /* ------------------------------------------------- Monochrome payments */

  var SHAPES = 'path, rect, circle, ellipse, polygon, polyline, line';

  function monochromeIcon(svg) {
    var viewBox = svg.viewBox && svg.viewBox.baseVal;
    if (!viewBox || !viewBox.width || !viewBox.height) return;
    var area = viewBox.width * viewBox.height;
    var touched = [];
    var painted = 0;

    Array.prototype.forEach.call(svg.querySelectorAll(SHAPES), function (shape) {
      if (shape.closest('defs, clipPath, mask, pattern')) return;
      var box;
      try { box = shape.getBBox(); } catch (e) { return; }
      var opacity = parseFloat(shape.getAttribute('opacity') || '1');
      var strokeOpacity = parseFloat(shape.getAttribute('stroke-opacity') || '1');
      var isPlate = box.width * box.height >= area * 0.8;
      var isHairline = opacity < 0.2 || (shape.getAttribute('fill') === 'none' && strokeOpacity < 0.2);
      touched.push([shape, shape.getAttribute('style')]);
      if (isPlate || isHairline) {
        shape.style.display = 'none';
        return;
      }
      var fill = shape.getAttribute('fill');
      shape.style.fill = fill === 'none' ? 'none' : 'currentColor';
      shape.style.fillOpacity = '1';
      if (shape.getAttribute('stroke') && shape.getAttribute('stroke') !== 'none') shape.style.stroke = 'currentColor';
      painted += 1;
    });

    if (!painted) {
      // Heuristic found nothing to keep: restore the original card.
      touched.forEach(function (entry) {
        if (entry[1] === null) entry[0].removeAttribute('style');
        else entry[0].setAttribute('style', entry[1]);
      });
    }
    svg.setAttribute('data-monochrome', painted ? 'done' : 'original');
  }

  function initPaymentIcons(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-payment-icons-monochrome] svg:not([data-monochrome])'), monochromeIcon);
  }

  /* ------------------------------------------------------------------ Init */

  function init(root) {
    root = root || document;
    initAccordions(root);
    initNewsletter(root);
    initPaymentIcons(root);
  }

  function boot() {
    init(document);
    initCookiePreferences();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    initCookiePreferences();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block) return;
    if (block.matches('[data-footer-accordion]')) block.open = true;
    // El bloque de newsletter ya no es un modal: es un bloque en línea, así
    // que seleccionarlo en el editor no necesita abrir/cerrar nada.
  });
})();
